import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { OpenLinkById } from '../../common/services/openlinkbyid';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AboutUsComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private openlink: OpenLinkById,
    private sanitizer: DomSanitizer) { }
  about_header;
  about_content;
  about_clickHere;
  about_compatibilityHeader;
  about_browsers;
  about_otherApplications;
  s3bucketbasepath;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    
    this.getaboutuscomponentlabels();
    this.graphQlService.getS3BucketPath().subscribe(data => {
      this.s3bucketbasepath = data;
    });
  }

  getaboutuscomponentlabels() {
    this.graphQlService.getAboutUsComponentLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.about_header = labels.filter(x => x.key == "about_header").map(y => y.value);
        this.about_content = labels.filter(x => x.key == "about_content").map(y => y.value);
        this.about_clickHere = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "about_clickHere").map(y => y.value));
        this.about_compatibilityHeader = labels.filter(x => x.key == "about_compatibilityHeader").map(y => y.value);
        this.about_browsers = labels.filter(x => x.key == "about_browsers").map(y => y.value);
        this.about_otherApplications = labels.filter(x => x.key == "about_otherApplications").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  openLinkById(event, isSitesBucket = false) {
    event.preventDefault();
    this.openlink.openLinkById(event, isSitesBucket);
  }
  onRightClick(event) {
    let id = event.target.getAttribute('id');
    if (id != null) {
      if (id.trim()[0] === '/') {
        event.target.href = event.target.id;
      }
      else {   
          event.target.href = this.s3bucketbasepath + "/" + event.target.id;       
      }
    }
  }
}
